import React from "react";
import FolderIcon from "@mui/icons-material/Folder";
import StarIcon from "@mui/icons-material/Star";
export default function MyFolderIcon(props) {
    if (props.folderKey === "faves_fggh2973jgbvbiu") {
        return <StarIcon className={props.className} />;
    } else {
        return <FolderIcon className={props.className} />;
    }
}
